var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"VideoPlayer__video"},[(!_vm.hasMarketingConsent && _vm.video && _vm.isMarketingEmbedUrl(_vm.video.video_url))?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getMarketingEmbedPlaceholderHtml())}}):_c('div',{attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.iframe)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }